import { render, staticRenderFns } from "./GoodsList.vue?vue&type=template&id=31f6e88c&scoped=true&"
import script from "./GoodsList.vue?vue&type=script&lang=js&"
export * from "./GoodsList.vue?vue&type=script&lang=js&"
import style0 from "./GoodsList.vue?vue&type=style&index=0&id=31f6e88c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f6e88c",
  null
  
)

export default component.exports